import Loader from "app/components/Loader";
import * as React from "react";
import { lazyLoad } from "utils/loadable";

export const Sprints = lazyLoad(
  () => import("./index"),
  (module) => module.SprintPages,
  {
    fallback: <Loader />,
  }
);
